<template>
  <section>
    <dt-modal
      id="contactEdit"
      name="contactEdit"
      ref="contactEdit"
      v-model="isVisibleContact"
      :modalSize="modalSize"
    >
      <div
        slot="header"
        class="custom-header"
      >
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-md-1">
            <a
              href="#"
              @click="close"
              class="custom-close"
            >
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div slot="body">
        <contact-tabs
          v-model="contactTab"
          :tabs="tabs"
          @validate="showTab"
          :isSave="isSave"
          @save="performSave"
        />
        <div
          class="row p-3"
          v-if="contactTab === 'Basic'"
        >
          <contact-basic
            ref="contactClient"
            @highlightSave="highlightSave"
          />
        </div>
        <div
          class="row p-3"
          v-if="contactTab === 'Vehicle'"
        >
          <contact-vehicles :contact="contactId" />
        </div>
        <div
          class="row p-3"
          v-if="contactTab === 'TestDrives'"
        >
          <contact-drives :contact="contactId" />
        </div>
      </div>
      <div
        class="custom-footer"
        slot="footer"
      >
        <div class="col-md-11">
          <span v-show="contactId !== null">id: {{ contactId }}</span>
          <dt-message
            v-model="message"
            class="alert alert-danger small mt-2"
          />
        </div>
        <div class="col-md-1">
          <button
            type="button"
            class="btn"
            :class="[{'btn-danger': isSave}, {'btn-light': !isSave}]"
            @click="finished()"
          >Finished</button>
        </div>
      </div>
    </dt-modal>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import DtModal from '@/components/utilities/modal/dt-modal.vue'
import DtMessage from '@/components/utilities/form/dt-message'
import ContactTabs from '@/components/contacts/tabs/contact-tabs'
import ContactBasic from '@/components/contacts/forms/contact-basic'
import ContactVehicles from '@/components/contacts/listings/contact-vehicles'
import ContactDrives from '@/components/contacts/listings/contact-drives.vue'
export default {
  name: 'contact-edit',
  components: {
    DtModal,
    DtMessage,
    ContactTabs,
    ContactBasic,
    ContactVehicles,
    ContactDrives
  },
  props: {
    value: {
      type: Object
    },
    contactTitle: String
  },
  data() {
    return {
      modalSize: 'modal-xl',
      contactTab: 'Basic',
      message: '',
      isSave: false,
      actionSomething: null,
      showContact: true
    }
  },
  async created() {
    this.contactTab = 'Basic'
  },
  mounted() {
    this.contactTab = 'Basic'
  },
  watch: {
    contact() {
      console.log('Editing Contact', this.contact)
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('contacts', ['contact']),
    title: {
      get() {
        let _title = 'Edit Contact'
        if (this.contactTitle !== undefined && this.contactTitle !== null) {
          _title = `Edit ${this.contactTitle}`
        }
        if (this.contact !== undefined && this.contact !== null) {
          _title += ` (${this.contact.firstName} ${this.contact.lastName})`
        }
        return _title
      }
    },
    tabs: {
      get() {
        let _tabs = ['Basic']
        if (this.contact !== undefined && this.contact !== null) {
          if (this.contact.contactTypeName === 'Owner') {
            _tabs = ['Basic', 'Vehicle', 'TestDrives']
          }
        }
        return _tabs
      }
    },
    contactId: {
      get() {
        return this.contact !== undefined && this.contact !== null
          ? this.contact.contact
          : null
      }
    },
    isVisibleContact: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    closeModal() {
      this.actionSomething = null
    },
    close() {
      this.contactTab = 'Basic'
      this.$emit('closing')
    },
    highlightSave(value) {
      this.isSave = value
    },
    async showTab(value) {
      let saved = false
      if (this.isSave) {
        saved = await this.performSave()
      } else {
        saved = true
      }
      if (saved) {
        this.contactTab = value
        this.isSave = false
      }
    },
    async performSave() {
      let success = false
      if (this.contactTab === 'Basic') {
        success = await this.$refs.contactClient.performSave()
        this.isSave = false
      }
      return success
    },
    async finished() {
      let saved = false
      if (this.isSave) {
        saved = await this.performSave()
      } else {
        saved = true
      }
      if (saved) {
        this.isSave = false
        this.contactTab = 'Basic'
        this.$emit('closing')
      }
    },
    showingContact() {
      this.contactTab = 'Basic'
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-textarea {
  height: 200px;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/forms/contact-edit.vue